import { useContext } from "react";

import { StrategyContext } from "../contexts/StrategyContext";

// The strategy job lifecycle (submit + poll) now lives in StrategyProvider so
// all consumers share one source of truth. This hook is a thin reader that
// preserves the previous return shape and adds `isOutOfDate` + `recalculate`.
export const useStrategy = () => {
  const { strategy, status, isLoading, error, isOutOfDate, recalculate } =
    useContext(StrategyContext);

  return { strategy, status, isLoading, error, isOutOfDate, recalculate };
};
